import React, { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import EndPoints from "src/Constants/EndPoints";
import CSS from "csstype";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import useLoading from "src/Hooks/Custom/useLoading";
import { useTranslation } from "react-i18next";
import i18n from "src/locales/i18n";

function SalePostlModal(props: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const { refetch, showModal, setModalVisibility, postData } = props;

  const { data: categoriesResponse } = useApiFetch(
    [EndPoints.saleCategoris],
    {}
  );

  const { Items: categories = [] } = categoriesResponse?.data ?? {};

  const {
    id,
    title: prevTitle = "",
    category_id = categories?.length ? categories[0].id : 1,
    message: msg = "",
    sale_price: prevSalePrice = 0,
    images: imgs = [],
  } = postData;

  const [loader, setLoader] = useState("inactive");
  const [categoryId, setCategoryId] = useState(category_id);
  const [title, setTitle] = useState(prevTitle);
  const [message, setMessage] = useState(msg);
  const [sellPrice, setSellPrice] = useState(prevSalePrice);
  const [imgBtnText, setImgBtnText] = useState("Add Photo");
  const [images, setImages] = useState<any>([]);
  const [imageUrls, setImageUrls] = useState<any>(imgs);
  const [deleteImgs, setDeleteImgs] = useState<any>([]);
  const [free, setFree] = useState<boolean>(prevSalePrice === 0);
  const [submit, setSubmit] = useState<boolean>();
  useLoading(loader);

  const [createPost, { status }] = useApiMutation({
     onSettled: refetch,
        onSuccess: () => {
          setModalVisibility(false);
          setLoader("success");
          AppStateHandler.stopLoader();
     },
  });

  const imageField: CSS.Properties = {
    width: "1",
    height: "1",
    opacity: "0",
    position: "absolute",
    overflow: "hidden",
    zIndex: -1,
  };

  const imgPreview: CSS.Properties = {
    width: "100%",
    height: "200px",
    padding: "10px",
  };

  const crossIcon: CSS.Properties = {
    color: "#e01515",
    position: "absolute",
    right: "0px",
    fontSize: "20px",
    cursor: "pointer",
  };

  const handleCreatePost = async () => {
    setSubmit(true);
    if (status === "loading" || imageUrls.length === 0) {
      return;
    }
    if (message.trim() === "" || title.trim() === "" || images.length === 0 ) {
      return;
    }
    setLoader("loading");
    const data = {
      postId: id,
      subId: user?.username,
      type: "SALE",
      category_id: Number(categoryId),
      message: message,
      title: title,
      sale_price: sellPrice,
      images: images,
      delete_images: deleteImgs,
    };
    try {
      await createPost({
        url: id ? EndPoints.updatePost : EndPoints.createPost,
        data: data,
      });
      setLoader("success");
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageRemove = (index: number, id: number) => {
    if (id) {
      setDeleteImgs([...deleteImgs, id]);
    }
    imageUrls.splice(index, 1);
    images.splice(index, 1);
    setImages(images);
    setImageUrls(imageUrls);
    setImgBtnText("Photos (" + images.length + ")");
  };

  const handleCategorySelected = (e: any) => {
    e.preventDefault();
    setCategoryId(e.target.value);
  };

  const fileSelectedHandler = async (imgs: any) => {
    const imgsArr = images;
    const urlsArr = imageUrls;
    for (const image of imgs) {
      const base64 = await convertToBase64(image);
      imgsArr.push(base64);
      urlsArr.push({ url: URL.createObjectURL(image) });
    }
    setImgBtnText("Photos (" + imgsArr.length + ")");
    setImages(imgsArr);
    setImageUrls(urlsArr);
  };

  const convertToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        resolve(fileReader.result);
      };
      fileReader.onerror = function (error) {
        console.log("Error: ", error);
        reject(error);
      };
    });
  };

  const sellingPriceHandler = (e: any) => {
    setSellPrice(Number(e.target.value));
    setFree(sellPrice === 0);
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(false);
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label className="mb-0">
                      {id ? t("Edit Sale Post") : t("Post an Item")}
                    </label>
                  </div>
                  <div className="form-row">
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''} col-md-12`}>
                      <label>{t("Category")}</label>
                      <select
                        className="form-control fz12"
                        value={categoryId}
                        onChange={handleCategorySelected}
                      >
                        {categories.map((category: any) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label>{t("Title")}</label>
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      className="form-control"
                      placeholder={t("Title")}
                    />
                    {title === '' && submit ? <span className="text-danger">*Title Required</span> : <></>}
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label>{t("Description")}</label>
                    <textarea
                      value={message}
                      className="form-control"
                      placeholder={t("Write a description")}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                    {message === '' && submit ? <span className="text-danger">*Description Required</span> : <></>}
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label>{t("Selling Price")}</label>
                    <input
                      type="number"
                      value={sellPrice}
                      onChange={sellingPriceHandler}
                      className="form-control"
                      placeholder="DZD 0"
                      min={0}
                    />
                    {sellPrice === 0 && !free && submit ? <span className="text-danger">*Selling Price Required</span> : <></>}
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''} form-check`}>
                    <input
                      type="checkbox"
                      checked={free}
                      onChange={() => setFree(!free)}
                      className="form-check-input"
                      id="exampleCheck1"
                    />
                    <label className={`form-check-label ${i18n.dir() === "rtl" ? "mr-3":""}`}>{t("Free")}</label>
                  </div>
                  <div className="d-sm-flex justify-content-between">
                    <div className="mb-3 mb-sm-0">
                      <label htmlFor="photos" className="mb-0">
                        <p className="d-inline-block btn custom_btn rounded text-secondary bg-transparent border fz15 mb-0">
                          <i
                            className={`fa fa-camera base_color fz18 ${i18n.dir()=== 'rtl'? "ml-3 " : "mr-3"}`}
                            aria-hidden="true"
                          ></i>
                          {imgBtnText}
                        </p>
                      </label>
                      <input
                        id="photos"
                        style={imageField}
                        type="file"
                        accept="image/*"
                        multiple={true}
                        onChange={(e) => fileSelectedHandler(e.target.files)}
                      />
                    </div>
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir() === "rtl" ?"ml-3": "mr-3"}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        type="button"
                        className="btn custom_btn fz14"
                        onClick={() => handleCreatePost()}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                  {imageUrls.length === 0 && submit ? <span className="text-danger">*Image Required</span> : <></>}
                </form>
                <VisibilityToggle visible={imageUrls.length !== 0}>
                  <div className="row">
                    {imageUrls.map((img: any, i: number) => {
                      return (
                        <div key={i} className="col-md-6" style={{}}>
                          <div style={{ position: "relative" }}>
                            <img
                              key={i}
                              style={imgPreview}
                              alt="London"
                              src={img.url}
                            ></img>
                            <i
                              key={i + "cross"}
                              style={crossIcon}
                              className="fa fa-times-circle"
                              aria-hidden="true"
                              onClick={() => handleImageRemove(i, img.id)}
                            ></i>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </VisibilityToggle>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default React.memo(SalePostlModal);
